var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9426 48.0009L36.6092 10.6676C36.1441 9.8468 35.4695 9.16409 34.6544 8.68911C33.8392 8.21412 32.9127 7.96387 31.9692 7.96387C31.0258 7.96387 30.0993 8.21412 29.2841 8.68911C28.469 9.16409 27.7944 9.8468 27.3292 10.6676L5.99591 48.0009C5.52573 48.8152 5.27918 49.7393 5.28126 50.6796C5.28335 51.6199 5.53398 52.5429 6.00776 53.3551C6.48155 54.1673 7.16163 54.8398 7.97909 55.3045C8.79655 55.7691 9.72233 56.0094 10.6626 56.0009H53.3292C54.265 56 55.184 55.7528 55.994 55.2843C56.804 54.8159 57.4765 54.1425 57.9439 53.3319C58.4114 52.5213 58.6573 51.602 58.6571 50.6662C58.6569 49.7305 58.4104 48.8113 57.9426 48.0009ZM31.9959 24.0009V34.6676V24.0009ZM31.9959 45.3343H32.0226H31.9959Z",
    fill: "#F22234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9959 24.0009V34.6676M31.9959 45.3343H32.0226M57.9426 48.0009L36.6092 10.6676C36.1441 9.8468 35.4695 9.16409 34.6544 8.68911C33.8392 8.21412 32.9127 7.96387 31.9692 7.96387C31.0258 7.96387 30.0993 8.21412 29.2841 8.68911C28.469 9.16409 27.7944 9.8468 27.3292 10.6676L5.99591 48.0009C5.52573 48.8152 5.27918 49.7393 5.28126 50.6796C5.28335 51.6199 5.53398 52.5429 6.00776 53.3551C6.48155 54.1673 7.16163 54.8398 7.97909 55.3045C8.79655 55.7691 9.72233 56.0094 10.6626 56.0009H53.3292C54.265 56 55.184 55.7528 55.994 55.2843C56.804 54.8159 57.4765 54.1425 57.9439 53.3319C58.4114 52.5213 58.6573 51.602 58.6571 50.6662C58.6569 49.7305 58.4104 48.8113 57.9426 48.0009Z",
    stroke: "#F22234",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.001V34.6676M32 45.3343H32.0267",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/dangerIcon.8e5e03d72976b56a6fb5d6f6ebee6c5c.svg";
export { ForwardRef as ReactComponent };